/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */
import React, { Component, Fragment } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CCol,
  CCollapse,
  CButton,
  CLink,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { InputGroup, InputGroupText, Label, Button } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import ContentItem from "../../../../components/Content/ContentItem";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class GeradorShow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      selected: [],
      filters: {},
      modal: false,
      modalOrder: false,
      content: [],
      activity: false,
      selection: [],
      contentList: {
        type: null,
        list: []
      },
      id: null,
      name: "",
      segment: "",
      discipline: "",
      modules: "",
      units: "",
      serie: "",
      series: [],
      resume: "",
      objective: "",
      year: "",
      pages: [],
      type: 9,
      ability_filter: true,
      flag: true,
      status: null,
      creatorId: null
    };
  }

  admRoles = [2, 3, 4];

  statusAdm = ["Em homologação", "Publicada"];

  statusCreator = ["Em produção", "Liberado"];

  componentDidMount() {
    const id = this.props.match.params?.id;

    if (id) {
      axios
        .all([
          axios.get(`${URL.api}content/los/listLosLos/${id}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }),
          axios.get(`${URL.api}content/los/singleView/${id}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }),
          axios.get(`${URL.api}classification/ability/filterStructure`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
        ])
        .then(
          axios.spread((resp, respAllDatas, respSegments) => {
            if (resp.data.success) {
              const data = resp.data.data;

              // Filtrar para pegar somente páginas (type_id=32)
              const childrenPages = data.children.filter(
                item => item.type_id === 32 && !item.deleted_at
              );

              this.setState({
                loading: false,
                id: data.id,
                name: data.name,
                resume: data.resume,
                objective: data.objective,
                year: data.year,
                pages: childrenPages,
                status: data.status,
                creatorId: data.user_id
              });
            }

            if (respAllDatas.data.success) {
              const data = respAllDatas.data.data;
              const {
                module_segment_id: segmentId,
                module_discipline_id: disciplineId,
                series
              } = data;

              if (respSegments.data.success) {
                const segments = respSegments.data.data;

                const segment = segments.find(
                  segment => segment.id === segmentId
                );

                if (segment && segment.disciplines) {
                  const discipline = segment.disciplines.find(
                    discipline => discipline.id === disciplineId
                  );

                  this.setState({
                    segment: segment.name,
                    discipline: discipline.name,
                    series
                  });
                }
              }
            }
          })
        );
    }
  }

  getSelected = select => {
    let { selected } = this.state;

    if (selected.length > 0) {
      selected.forEach((item, idx) => {
        if (item.id === select.id) {
          selected.splice(idx, 1);
        }
      });
    }

    selected.push(select);

    this.setState({ selected }, () => {
      let list = [];
      let { selected } = this.state;

      // ajusteMarvin ajustar pós inserir aula if (this.props.type === 1) {
      if (this.state.type === "0") {
        selected.forEach(lesson => {
          lesson.slides.forEach(slide => {
            if (slide.checked) {
              slide.father = lesson.id;
              list.push(slide);
            }
          });
        });
      } else {
        list = this.state.contentList.list;
        if (list.length > 0) {
          list.forEach((content, idx) => {
            if (content.id === select.id) {
              list.splice(idx, 1);
            } else {
              list.push(select);
            }
          });
        } else {
          list.push(select);
        }
      }

      this.setState({
        contentList: {
          type: this.state.content[0].id,
          list
        }
      });
    });
  };

  edit = () => {
    this.props.history.push(`/tools/gerador/edit/${this.state.id}`);
  };

  show = () => {
    if (this.state.status === "Em produção") {
      this.props.history.push(`/tools/gerador/build/${this.state.id}`);
    } else {
      toastr.error('Erro! A aula precisa estar "Em produção" para ser editada');
    }
  };

  openClass = () => {
    if (this.state.pages.length > 0) {
      window.open(
        `/content/view/${this.state.id}?title=${this.state.name}`,
        "_blank"
      );
    } else {
      toastr.error("Erro! A aula ainda não tem conteúdo!");
    }
  };

  openPage = page => {
    window.open(
      `${URL.public}uploads/gerador/${this.state.id}/${page.id}`,
      "_blank"
    );
  };

  updateStatus = async status => {
    let obj = {
      status
    };

    const resp = await axios.post(
      `${URL.api}content/los/update/${this.state.id}`,
      obj,
      {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      }
    );

    if (resp.data?.success) {
      const respLos = await axios.get(
        `${URL.api}content/los/singleView/${this.state.id}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );
      if (respLos.data?.data) {
        this.setState({
          status: respLos.data.data.status
        });
      }
    }
  };

  render() {
    return (
      <div className="animated">
        <Breadcrumb current={this.props.currentRoute} />
        <CCard>
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <div className="d-flex align-items-center mb-1">
                <h4 className="card-title m-0 border-0 mr-1">
                  {this.state.name}
                </h4>
              </div>
              <div className="small text-muted">{this.state.objective}</div>
            </div>
            {this.state.creatorId === this.props.user.user.id && (
              <div className="d-inline-flex flex-row">
                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center mr-2"
                  onClick={() => this.openClass()}
                  disabled={this.state.loading}
                >
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-eye mr-2"></i>
                    Visualizar
                  </span>
                </CButton>

                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center mr-2"
                  onClick={() => this.show()}
                  disabled={this.state.loading}
                >
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-pencil mr-2"></i>
                    {this.state.pages?.length > 0 ? "Editar" : "Criar"}
                  </span>
                </CButton>

                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => this.edit()}
                  disabled={this.state.loading}
                >
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-gear"></i>
                  </span>
                </CButton>
              </div>
            )}
          </CCardHeader>
          <CCardBody>
            <CCollapse show className="d-lg-block">
              <div
                className="d-flex flex-column flex-md-row "
                style={{ paddingBottom: "1.25rem" }}
              >
                <div className="flex-1">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">
                      Segmento
                    </Label>
                  </div>
                  <InputGroup>
                    <InputGroupText className="bg-white text-primary flex-1">
                      {this.state.segment || "-"}
                    </InputGroupText>
                  </InputGroup>
                </div>

                <div className="p-2"></div>

                <div className="flex-1">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">Série</Label>
                  </div>
                  <CSelect
                    placeholder="Séries"
                    value={this.state.serie}
                    onChange={e => this.setState({ serie: e.value })}
                  >
                    <option>Série</option>
                    {this.state.series.map(serie => (
                      <option key={serie.id} value={serie.name}>
                        {serie.name}
                      </option>
                    ))}
                  </CSelect>
                </div>

                <div className="p-2"></div>

                <div className="flex-1">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">
                      Componente curricular
                    </Label>
                  </div>
                  <InputGroup>
                    <InputGroupText className="bg-white text-primary flex-1">
                      {this.state.discipline || "-"}
                    </InputGroupText>
                  </InputGroup>
                </div>

                <div className="p-2"></div>

                <div className="flex-1">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">
                      {this.state.ability_filter
                        ? "Habilidades BNCC"
                        : "Eixo temático BNCC"}
                      <CLink
                        className="ml-2"
                        onClick={() =>
                          this.setState(state => ({
                            ability_filter: !state.ability_filter
                          }))
                        }
                      >
                        (
                        {this.state.ability_filter
                          ? "Eixo temático BNCC"
                          : "Habilidades BNCC"}
                        )
                      </CLink>
                    </Label>
                  </div>
                  <InputGroup>
                    <InputGroupText className="bg-white text-primary flex-1">
                      Todos
                    </InputGroupText>
                  </InputGroup>
                </div>
              </div>
            </CCollapse>

            {this.state.resume && (
              <div className="cardContent" style={{ minHeight: 0 }}>
                <div>
                  <Label className="d-block w-100 text-ellipsis">Sinopse</Label>

                  <div className="m-0 border-0 mr-1 ml-3">
                    <p className="text-justify">{this.state.resume}</p>
                  </div>
                </div>
              </div>
            )}

            <div className="cardContent" style={{ minHeight: 0, width: "30%" }}>
              <div>
                <Label className="d-block w-100 text-ellipsis">Status</Label>
                {this.state.status && (
                  <InputGroup>
                    <InputGroupText className="bg-white mr-1 p-2 text-primary flex-1">
                      {this.state.status || "-"}
                    </InputGroupText>

                    {/* Botão do criador para colocar em produção ou liberar */}
                    {this.state.creatorId === this.props.user.user.id &&
                      this.statusCreator.includes(this.state.status) && (
                        <Button
                          onClick={() => {
                            if (this.state.pages?.length > 0) {
                              this.state.status === "Em produção"
                                ? this.updateStatus("Liberado")
                                : this.updateStatus("Em produção");
                            } else {
                              toastr.error(
                                "Erro! A aula ainda não tem conteúdo!"
                              );
                            }
                          }}
                          color={
                            this.state.status === "Em produção"
                              ? "success"
                              : "danger"
                          }
                        >
                          {this.state.status === "Em produção"
                            ? "Liberar"
                            : "Produção"}
                        </Button>
                      )}

                    {/* Botão do adm para publicar ou recusar */}
                    {this.admRoles.includes(
                      this.props.general.active_roles.role_id
                    ) &&
                      this.statusAdm.includes(this.state.status) && (
                        <>
                          <Button
                            onClick={() =>
                              this.state.status === "Em homologação"
                                ? this.updateStatus("Publicada")
                                : this.updateStatus("Em homologação")
                            }
                            color={
                              this.state.status === "Em homologação"
                                ? "warning"
                                : "secondary"
                            }
                            className="mr-1"
                          >
                            {this.state.status === "Em homologação"
                              ? "Publicar"
                              : "Homologar"}
                          </Button>
                          {this.state.status === "Em homologação" && (
                            <Button
                              onClick={() =>
                                this.state.status === "Em homologação"
                                  ? this.updateStatus("Liberado")
                                  : null
                              }
                              color="danger"
                            >
                              Recusar
                            </Button>
                          )}
                        </>
                      )}
                  </InputGroup>
                )}
                {this.state.creatorId === this.props.user.user.id &&
                  this.state.status === "Liberado" && (
                    <p className="m-2">
                      Aula liberada!{" "}
                      <span
                        className="d-inline"
                        onClick={() => this.updateStatus("Em homologação")}
                        style={{
                          color: "#186daa",
                          cursor: "pointer",
                          textDecoration: "underline",
                          marginBottom: 60
                        }}
                      >
                        Torná-la Pública?
                      </span>
                    </p>
                  )}

                {this.state.creatorId === this.props.user.user.id &&
                  this.state.status === "Em homologação" && (
                    <p className="m-2">
                      Aula em homologação! Deseja{" "}
                      <span
                        className="d-inline"
                        onClick={() => this.updateStatus("Liberado")}
                        style={{
                          color: "#186daa",
                          cursor: "pointer",
                          textDecoration: "underline",
                          marginBottom: 60
                        }}
                      >
                        cancelar a publicação?
                      </span>
                    </p>
                  )}
              </div>
            </div>

            <div className="cardContent" style={{ minHeight: 0 }}>
              {this.state.loading ? (
                <Loading />
              ) : this.state.pages.length > 0 ? (
                <div>
                  <h4 className="card-title m-0 border-0 mr-1 mb-3">Páginas</h4>
                  <div className="contentArea row">
                    <Fragment>
                      {this.state.pages.map(item => (
                        <CCol
                          xs="12"
                          md="6"
                          lg="4"
                          xl="3"
                          key={`type-${item.id}`}
                        >
                          <ContentItem
                            type={32}
                            key={item.id}
                            content={item}
                            icon="television"
                            color="primary"
                            getSelected={this.getSelected}
                            currentRoute={this.props.currentRoute}
                            onClick={() => this.openPage(item)}
                          />
                        </CCol>
                      ))}
                    </Fragment>
                  </div>
                </div>
              ) : (
                <div className="text-muted p-4 d-flex justify-content-center">
                  Aula sem páginas
                </div>
              )}
            </div>
          </CCardBody>
          <ProtectedRoute routeId={this.props.currentRoute} />
        </CCard>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GeradorShow);
